import * as React from 'react'
import TwitterSlider from 'sections/HomePage/TwitterSlider'
import cx from 'classnames'
import { inject, observer } from 'mobx-react'
import TimFerrissSection from './TimFerrissSection'
import JoePompSection from './JoePompSection'
import { FAQ as UKFAQ } from 'sections/UkLP/FAQ'
import { FAQ as EUFAQ } from 'sections/EULP/FAQ'
import { FAQ as AUFAQ } from 'sections/AULP/FAQ'
import { RootStore } from 'stores'
import { Product } from 'products/types'
import { TransformSleepStepsCover } from 'components/Pod 3 LP/Sections/TransformSleepSteps'
import { FAQ } from 'components/_sections/FAQ'
import { getFAQs } from 'components/_sections/FAQ/_faqs'
import { SplitRailLP } from 'components/SplitRailShowcase'
import { AdtPixel } from 'components/_pixels'
import { MagicScroll } from 'components/Pod 3 LP/Sections/MagicScroll/MagicScroll'
import { FeatureIcons } from 'components/Pod 3 LP/Sections/FeatureIcons/FeatureIcons'
import { LifestyleImageGridImages } from 'components/Pod 3 LP/Sections/LifestyleImageGrid'
import { Awards } from 'sections/Awards'
import { TweetsBFCM } from 'components/_sections/TweetsBFCM/TweetsBFCM'
import { ExplainerSection } from 'sections/ExplainerSection'

interface PodTechCoverVariantCProps {
	rootStore: RootStore
	podSelected: boolean
	product?: Product
}

const PodTechCoverVariantC: React.FC<PodTechCoverVariantCProps> = inject('rootStore')(
	observer((props) => {
		const timFerrissVisitor =
			(process.browser && window && sessionStorage && sessionStorage.getItem('utm_source') === 'tim-ferriss') ||
			(window && (window.location.href.toLowerCase().includes('/tim') || window.location.href.includes('tim-ferriss')))
		const joePompVisitor =
			(process.browser && window && sessionStorage && sessionStorage.getItem('utm_source') === 'joe-pomp') ||
			(window && (window.location.href.toLowerCase().includes('/joe-pomp') || window.location.href.toLowerCase().includes('/joe')))
		const settings = props.rootStore.settingsStore
		const isUK = settings.isUK
		const isEU = settings.isEULegacy
		const isAU = settings.isAU

		const promo = settings.settings.promoCode

		return (
			<>
				{joePompVisitor || timFerrissVisitor ? (
					<>
						<div className="bg-white">
							{isUK && <UKFAQ />}
							{isEU && <EUFAQ />}
							{isAU && <AUFAQ />}

							<section>
								<Awards />
							</section>

							<section
								className={'inner-paddings-x inner-paddings-y bg-white'}
								id={'improve-your-sleep'}
							>
								<LifestyleImageGridImages />
							</section>

							<section>
								<MagicScroll />
							</section>
							<section className={'inner-paddings-x bg-white'}>
								<FeatureIcons />
							</section>
							<section className="inner-paddings-y bg-white inner-paddings-x">
								<TransformSleepStepsCover />
							</section>
							<section className={'bg-black text-white inner-paddings-x inner-paddings-y'}>
								<SplitRailLP />
							</section>
							<section>
								<TwitterSlider />
							</section>
						</div>
						{joePompVisitor && <JoePompSection />}
						{timFerrissVisitor && <TimFerrissSection />}
						<AdtPixel id="6565" />
					</>
				) : (
					<div>
						<section className={cx('inner-paddings-y', 'bg-mid-grey', 'text-black')}>
							<TweetsBFCM />
						</section>
						<section>
							<ExplainerSection
								video="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/f4a47a1b152841b08c1e7f563b419e7c.mp4"
								caption="Pod 3 Cover explained"
								id="Pod Cover Shop"
								thumb="https://eightsleep.imgix.net/cover_thumb_c819aa0b-3427-422e-8698-6e2b3bedfc59.jpg?v=1669185935"
							/>
						</section>
						<section className="inner-paddings-y bg-white inner-paddings-x">
							<TransformSleepStepsCover />
						</section>
						<section className={'bg-black text-white inner-paddings-x inner-paddings-y'}>
							<SplitRailLP />
						</section>
						<section className={'inner-paddings-x inner-paddings-y bg-white'}>
							<FAQ
								items={getFAQs('cover', settings.currentRegion, promo === 'members')}
								inverted
							/>
						</section>

						<AdtPixel id="6565" />
					</div>
				)}
			</>
		)
	})
)

export default PodTechCoverVariantC
